// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__2bpoN","open":"style_open__1TSHV","openAnimation":"style_openAnimation__3RdWL","close":"style_close__1CTIt","closeAnimation":"style_closeAnimation__10xVD"};